export const GroundTeamEventLogTypes = {
  SET_GROUND_TEAM_EVENT_LOGS: 'SET_GROUND_TEAM_EVENT_LOGS'
};
